import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  imports: [NgIf, NgClass, AsyncPipe],
})
export class ToasterComponent {
  protected toasterService = inject(ToasterService);

  getIconPath(type: string): string {
    switch (type) {
      case 'error':
        return '../../../assets/icons/icon-error.svg';
      case 'success':
        return '../../../assets/icons/icon-success.svg';
      case 'warning':
        return '../../../assets/icons/icon-warning.svg';
      default:
        return '';
    }
  }

  getIconAlt(type: string): string {
    switch (type) {
      case 'error':
        return 'Ícone de erro';
      case 'success':
        return 'Ícone de sucesso';
      case 'warning':
        return 'Ícone de alerta';
      default:
        return '';
    }
  }
}
